/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptWorkspaceInviteInput } from "../models/AcceptWorkspaceInviteInput";
import type { AjaxResponseOfIdentifyWorkspaceInviteResultDto } from "../models/AjaxResponseOfIdentifyWorkspaceInviteResultDto";
import type { AjaxResponseOfWorkspaceInviteCompletedDto } from "../models/AjaxResponseOfWorkspaceInviteCompletedDto";
import type { AjaxResponseOfWorkspaceInvitePresentationDto } from "../models/AjaxResponseOfWorkspaceInvitePresentationDto";
import type { IdentifyWorkspaceInviteInput } from "../models/IdentifyWorkspaceInviteInput";
import type { RegisterWorkspaceInviteInput } from "../models/RegisterWorkspaceInviteInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class WorkspaceInvitesAppServiceAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfWorkspaceInvitePresentationDto Success
   * @throws ApiError
   */
  public getWorkspaceInvite({
    token,
  }: {
    token: string;
  }): CancelablePromise<AjaxResponseOfWorkspaceInvitePresentationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/workspace-invites/{token}",
      path: {
        token: token,
      },
    });
  }
  /**
   * @returns AjaxResponseOfIdentifyWorkspaceInviteResultDto Success
   * @throws ApiError
   */
  public identifyWorkspaceInvite({
    token,
    requestBody,
  }: {
    token: string;
    requestBody?: IdentifyWorkspaceInviteInput;
  }): CancelablePromise<AjaxResponseOfIdentifyWorkspaceInviteResultDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/workspace-invites/{token}/identify",
      path: {
        token: token,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfWorkspaceInviteCompletedDto Success
   * @throws ApiError
   */
  public registerWorkspaceInvite({
    token,
    requestBody,
  }: {
    token: string;
    requestBody?: RegisterWorkspaceInviteInput;
  }): CancelablePromise<AjaxResponseOfWorkspaceInviteCompletedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/workspace-invites/{token}/register",
      path: {
        token: token,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfWorkspaceInviteCompletedDto Success
   * @throws ApiError
   */
  public acceptWorkspaceInvite({
    token,
    requestBody,
  }: {
    token: string;
    requestBody?: AcceptWorkspaceInviteInput;
  }): CancelablePromise<AjaxResponseOfWorkspaceInviteCompletedDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/workspace-invites/{token}/accept",
      path: {
        token: token,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
